import { assign, createMachine } from "xstate";
import { fetchOffers } from "@nju/data-access-portal-offers";
import { fetchOrchestrators } from "@nju/data-access-portal-orchestrator";

interface IContext {
  productOfferGrantValue: string;
  productOfferPrice: number;
}

type IEvent =
  | { type: "ERROR" }
  | { type: "NEW_ORDER" }
  | { type: "NEW_ORDER_SUCCESS" }
  | {
      type: "FETCH_DATA_SUCCESS";
      productOfferPrice: number;
      productOfferGrantValue: string;
    }
  | { type: "ANOTHER_ORDER_IN_PROGRESS" };

export const newOrderMachine = createMachine(
  {
    schema: {
      context: {
        productOfferGrantValue: "",
        productOfferPrice: 0,
      } as IContext,
      events: {} as IEvent,
    },
    initial: "init",
    states: {
      init: {
        invoke: {
          src: "fetchData",
        },
        on: {
          FETCH_DATA_SUCCESS: {
            actions: "setData",
            target: "ready",
          },
          ERROR: {
            target: "error",
          },
        },
      },
      ready: {
        on: {
          NEW_ORDER: {
            target: "newOrder",
          },
        },
      },
      newOrder: {
        invoke: {
          src: "newOrder",
        },
        on: {
          NEW_ORDER_SUCCESS: {
            actions: "onNewOrderSuccess",
          },
          ANOTHER_ORDER_IN_PROGRESS: {
            actions: "onAnotherOrderInProgress",
          },
          ERROR: {
            target: "error",
          },
        },
      },
      error: {
        type: "final",
      },
    },
  },
  {
    actions: {
      setData: assign<IContext, IEvent>((context, event) => {
        if (event.type === "FETCH_DATA_SUCCESS") {
          return {
            productOfferGrantValue: event.productOfferGrantValue,
            productOfferPrice: event.productOfferPrice,
          };
        }

        return context;
      }),
    },
    services: {
      fetchData: () => {
        return async (callback) => {
          try {
            const offers = (await fetchOffers()).unwrap();
            const productOfferPrice =
              offers.dataPackage?.productOfferingPrice?.price.amount || 0;
            const productOfferGrantValue = offers.dataPackage?.balances?.find(
              (item) => {
                return ["21268", "21129"].includes(item.balanceId);
              },
            )?.grantValue;

            if (
              productOfferPrice === undefined ||
              productOfferGrantValue === undefined
            ) {
              return callback({ type: "ERROR" });
            }

            return callback({
              type: "FETCH_DATA_SUCCESS",
              productOfferPrice,
              productOfferGrantValue,
            });
          } catch {
            callback({ type: "ERROR" });
          }
        };
      },
      newOrder: () => {
        return async (callback) => {
          try {
            const { multiOrder } = (await fetchOrchestrators()).unwrap();

            if (multiOrder && multiOrder.state !== "START") {
              return callback({ type: "ANOTHER_ORDER_IN_PROGRESS" });
            }

            return callback({ type: "NEW_ORDER_SUCCESS" });
          } catch {
            return callback({ type: "ERROR" });
          }
        };
      },
    },
  },
);
